// eslint-disable-next-line no-restricted-imports
import {
  Query_LegalClientController_GetById_OrganizationalAndLegalForm_OrganizationType as OrganizationTypeApi,
  OrganizationalAndLegalFormFragment,
} from 'api/generated/graphql';
import {
  OrganizationalAndLegalFormEntity,
  OrganizationType,
} from 'api/types/entity';

const organizationTypeMap: Record<OrganizationTypeApi, OrganizationType> = {
  [OrganizationTypeApi.Commercial]: OrganizationType.Commercial,
  [OrganizationTypeApi.NonCommercial]: OrganizationType.NonCommercial,
};

export const parseOrganizationalAndLegalFormEntity = (
  data: OrganizationalAndLegalFormFragment | undefined
): OrganizationalAndLegalFormEntity | undefined =>
  data
    ? {
        isFinancialInstitution: data.isFinancialInstitution ?? undefined,
        isUnincorporatedStructure: data.isUnincorporatedStructure ?? undefined,
        organizationalAndLegalForm: data.organizationalAndLegalForm,
        organizationType: data.organizationType
          ? organizationTypeMap[data.organizationType]
          : undefined,
      }
    : undefined;
